export function isGapiRequestError(error: unknown): error is GapiRequestError {
  const gapiError = error as GapiRequestError;
  return (
    gapiError.body !== undefined &&
    gapiError.headers !== undefined &&
    gapiError.status !== undefined &&
    gapiError.statusText !== undefined
  );
}
